export const DATA_COLUMNS = [
    { field: 'title', label: 'Vulnerability' },
    { field: 'published', label: 'Published' },
    { field: 'cvss.score', label: 'CVSS' },
    { field: 'enchantments.score.value', label: 'AI score' },
    { field: 'epss.epss', label: 'EPSS' },
    { field: 'enchantments.exploitation.wildExploited', label: 'In wild' },
    { field: 'exploits_count', label: 'Exploits' },
    { field: 'webApplicability.applicable', label: 'Web' },
    { field: 'viewCount', label: 'Seen' }
] as const;

export const FIELDS = DATA_COLUMNS.map(({ field }) => field);

export const DIRECTIONS = ['asc', 'desc'] as const;
